import { Component, inject } from '@angular/core';
import { CardComponent } from '../../../ui/card/card.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../../ui/button/button.component';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-student-tests-shell',
  standalone: true,
  imports: [TranslateModule, RouterOutlet],
  templateUrl: './tests.component.html',
  styleUrl: './tests.component.css',
})
export class TestsComponent {}
